import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Recurrence } from '../models/recurrence';
import { CoreResponse } from '../models/core-response';
import { map, tap } from 'rxjs/operators';
import { PeriodService } from './period.service';
import { HelperService } from './helper.service';

@Injectable({
    providedIn: 'root'
})

export class RecurrenceService implements OnDestroy {
    DEFAULT_ID: number = -1;
    defaultRecurrence: Recurrence = new Recurrence(this.DEFAULT_ID, 'All', null, null, null, null);

    private url: string = environment.apiEndpoint + '/Recurrence';
    private recurrences$: Observable<Recurrence[]>;
    private allPeriodsRecurrenceId$: Observable<number>;
    private periodChange$: Subscription;

    constructor(private http: HttpClient, private periodService: PeriodService, private helperService: HelperService) {
        this.periodChange$ = this.periodService.getPeriodEvents().subscribe(() => this.resetCache());
    }

    resetCache() {
        this.recurrences$ = null;
        this.allPeriodsRecurrenceId$ = null;
    }

    getRecurrenceById(recurrenceId: number): Observable<Recurrence> {
        return this.GetAllRecurrences().pipe(map(recurrences => recurrences.find(x => x.id === recurrenceId)));
    }

    getAllPeriodsReccurenceId(): Observable<number> {
        return this.helperService.getCached(this.allPeriodsRecurrenceId$, this.http.get<number>(this.url + '/allPeriods'));
    }

    GetAllPublishedRecurrences(): Observable<Recurrence[]> {
        return forkJoin([
            this.GetAllRecurrences(), 
            this.periodService.getPeriods()
        ]).pipe(map(([recurrences, periods]) => 
            recurrences.filter(r => periods.some(p => p.recurrenceId === r.id && p.isPublished))
        ));
    }

    GetAllRecurrences(): Observable<Recurrence[]> {
        return this.helperService.getCached(this.recurrences$, this.http.get<Recurrence[]>(this.url + '/allRecurrences'));
    }

    insertRecurrence(recurrence: Recurrence): Observable<Recurrence> {
        return this.http.post<Recurrence>(this.url, recurrence).pipe(tap(this.resetCache));
    }

    updateRecurrence(recurrence: Recurrence): Observable<number> {
        return this.http.put<number>(this.url, recurrence).pipe(tap(this.resetCache));
    }

    deleteRecurrence(id: number): Observable<CoreResponse<number>> {
        return this.http.delete<CoreResponse<number>>(this.url + '/' + id).pipe(tap(this.resetCache));
    }

    ngOnDestroy(): void {
        this.periodChange$.unsubscribe();
    }
}
